export enum CrmSegment {
  Cancelled = 'CANCELLED',
  ExclusiveBuyers = 'EXCLUSIVE_BUYERS',
  FreeOffers = 'FREE_OFFERS',
  Leads = 'LEADS',
  Subscribed = 'SUBSCRIBED',
}
